import styled from 'styled-components';

export const Box = styled.div`
  min-width: ${props => props.theme.rem(20)};
  min-height: ${props => props.theme.rem(20)};
  border: ${props => props.theme.checkbox.boxBorder};
  background: transparent;
  border-radius: 4px;
  margin-right: 10px;
  z-index: 0;
  display: flex;
  align-items: center;
  border-radius: 4px;
`;

export const Label = styled.label`
  display: flex;
  cursor: pointer;
  align-items: center;
  font-size: ${props => props.theme.rem(16)};
  color: ${props => props.theme.checkbox.color};
  height: 35px;
  white-space: nowrap;

  svg {
    width: 13px;
    position: relative;
    display: block;
    margin-right: ${props => props.theme.space(2)};
    fill: ${props => props.theme.checkbox.color};
  }

  ${Box} {
    svg {
      display: none;
    }
  }

  .label {
    & > p {
      font-size: ${props => props.theme.rem(12)};
      line-height: ${props => props.theme.rem(16)};
      color: ${props => props.theme.checkbox.helperText};
      margin-top: 2px;
    }
  }
`;

export const Input = styled.input`
  display: none;

  &:checked ~ ${Label} {
    ${Box} {
      border-color: ${props => props.theme.checkbox.checked.borderColor};
      background-color: ${props => props.theme.checkbox.checked.background};
      box-shadow: none;

      svg {
        width: 13px;
        display: block;
        transform: translateX(3px);
        margin-right: 0;
        fill: ${props => props.theme.checkbox.checked.color};
      }
    }
  }
`;
